import { MapboxGeoJSONFeature } from "mapbox-gl"
import { DashboardSourceNames } from "../dashboard.constants"

export const MapPopUp = ({
  feature,
  tesLabel,
  compositeLabel,
}: {
  feature: MapboxGeoJSONFeature
  tesLabel: string
  compositeLabel: string
}) => {
  const { properties, layer } = feature
  if (layer.id === DashboardSourceNames.AGGREGATED_MUNICIPALITY) {
    return `<div class="text-center">
        <div class="text-gray-500 text-subtitle">${properties?.incorporated_place_name}</div>
      </div>`
  }
  if (layer.id === DashboardSourceNames.MUNICIPALITY) {
    return `<div class="text-center">
        <div class="text-3xl font-bold text-brand-green-dark">${
          properties?.incorporated_place_mean_tree_equity_score
        }</div>
        <div class="text-sm text-brand-green-dark whitespace-nowrap">${compositeLabel}</div>
        <div class="text-xs text-gray-500">${properties!.incorporated_place_name}, ${
          properties!.state
        }</div>
      </div>`
  }
  if (layer.id === DashboardSourceNames.BLOCKGROUP) {
    return `<div class="text-center">
        <div class="text-3xl font-bold text-brand-green-dark">${properties?.tree_equity_score}</div>
        <div class="text-brand-green-dark text-annotation text-center leading-tight">${tesLabel}</div>
        <div class="text-gray-500 text-annotation">BG ${properties!.id}</div>
      </div>`
  }

  return null
}
